export const createModeGraphicTooltip = (dataGraphic) => (context) => {
  let tooltipEl = document.getElementById('chartjs-tooltip');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.pointerEvents = 'none';
    document.body.appendChild(tooltipEl);
  }

  // Keep tooltip above MUI Drawer/Sidebar layers.
  tooltipEl.style.zIndex = '1500';
  tooltipEl.style.background = '#FFFFFF';
  tooltipEl.style.border = '1px solid rgba(148, 163, 184, 0.28)';
  tooltipEl.style.borderRadius = '12px';
  tooltipEl.style.boxShadow = '0 18px 42px rgba(15, 23, 42, 0.16)';
  tooltipEl.style.color = '#253145';
  tooltipEl.style.minWidth = '196px';
  tooltipEl.style.opacity = '1';
  tooltipEl.style.transform = 'translateY(-6px)';
  tooltipEl.style.transition = 'opacity 120ms ease, transform 120ms ease';

  const tooltipModel = context.tooltip;
  if (tooltipModel.opacity === 0) {
    tooltipEl.classList.remove('show');
    tooltipEl.style.opacity = '0';
    return;
  }

  tooltipEl.classList.add('show');
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  const label = tooltipModel.dataPoints[0].label;
  const dataForPoint = dataGraphic.filter((item) => item.month_year === label);

  const grouped = dataForPoint.reduce((acc, item) => {
    const statusKey = item.final_status.replace('total_', '');
    acc[statusKey] = (acc[statusKey] || 0) + parseInt(item.status_count || 0, 10);
    return acc;
  }, {});

  grouped.total_geral = Object.values(grouped).reduce((sum, value) => sum + value, 0);

  const statusMap = {
    delivered: { label: 'Entregue', color: '#25D366' },
    failed: { label: 'Falhou', color: '#E53935' },
    not_confirmed: { label: 'Não Confirmado', color: '#757575' },
    read: { label: 'Lido', color: '#4FC3F7' },
    received: { label: 'Recebido', color: '#9C27B0' },
    unknown: { label: 'Desconhecido', color: '#9E9E9E' },
    waiting: { label: 'Aguardando', color: '#FFC107' },
    total_geral: { label: 'Total Geral', color: '#673AB7' },
  };

  const formatNumberWithSpaces = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  const htmlLines = [
    `<div style="font-size: 13px; font-weight: 700; margin: 0 0 10px; text-align: left;">${label}</div>`,
    ...Object.entries(grouped).map(([status, value]) => {
      const statusInfo = statusMap[status] || { label: status, color: '#000' };
      return `
        <div style="display: flex; align-items: center; gap: 10px; margin: 8px 0; font-size: 12px;">
          <div style="display: flex; align-items: center; flex-grow: 1; min-width: 0;">
            <div style="
              width: 8px;
              height: 8px;
              background-color: ${statusInfo.color};
              border-radius: 50%;
              margin-right: 8px;
              box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.12);
            "></div>
            <span style="color: #64748B; font-weight: 600; white-space: nowrap;">${statusInfo.label}</span>
          </div>
          <div style="min-width: 48px; text-align: right;">
            <strong style="color: #253145; font-weight: 700;">${formatNumberWithSpaces(value)}</strong>
          </div>
        </div>
      `;
    }),
  ];

  tooltipEl.innerHTML = htmlLines.join('');

  const canvas = context.chart.canvas;
  const position = canvas.getBoundingClientRect();

  const tooltipWidth = tooltipEl.offsetWidth;
  const tooltipHeight = tooltipEl.offsetHeight;

  const pageX = position.left + window.pageXOffset + tooltipModel.caretX;
  const pageY = position.top + window.pageYOffset + tooltipModel.caretY - tooltipHeight;

  let left = pageX;
  const top = pageY;
  const viewportRight = window.pageXOffset + window.innerWidth;

  if (left + tooltipWidth > viewportRight) {
    left = pageX - tooltipWidth - 20;
    if (left < window.pageXOffset) {
      left = window.pageXOffset + 5;
    }
  }

  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
  tooltipEl.style.font = 'Inter, Roboto, Arial, sans-serif';
  tooltipEl.style.padding = '12px 14px';
  tooltipEl.style.pointerEvents = 'none';
};
